import React, { useState, useCallback, useMemo, useRef } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  ColumnFixing,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import Box from "@mui/material/Box";
import { api_path } from "../../shared.js";
export default function CustomerDashboardDatagrid({ userId, stageId, page }) {
  const token = process.env.REACT_APP_API_TOKEN;
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));
  //   React.useEffect(() => {
  //   if (stageId ) {
  //     console.log("Stage ที่เลือก:", stageId );
  //   }
  // }, [stageId ]);
  const customerDataSource = useMemo(() => {
    return new CustomStore({
      key: "CRM_CUSCODE",
      load: async (loadOptions) => {
        const skip = loadOptions.skip ?? 0;
        const take = loadOptions.take ?? 5000;
        const pageNumber = Math.floor(skip / take) + 1;

        const sortField = loadOptions.sort?.[0]?.selector ?? "CREATE_DATE";
        const sortOrder =
          loadOptions.sort?.[0]?.desc !== false ? "DESC" : "ASC";

        const params = new URLSearchParams({
          SALES_CODE: userId,
          CRM_UID: userId,
          role: getUserRole,
          SMF_CUSCODE: "",
          CUSTOMER_NAME: "",
          TAX_ID: "",
          CUSTOMER_STATUS:
            stageId !== null && stageId !== undefined ? stageId : "",
          CUSTOMER_TYPE: "",
          CUSTOMER_BU: "",
          SALES_ROLE: getUserRole,
          page: page,
          load: "",
          skip,
          take,
          sortField,
          sortOrder,
        }).toString();

        const response = await fetch(
          api_path + `/customer/customers-paging.php?${params}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const result = await response.json();

        const cleanData = (result.data ?? []).map((item) => ({
          ...item,
          CUSTOMER_NAME: item.CUSTOMER_NAME?.trim() || "(ไม่มีข้อมูล)",
          TAX_ID: item.TAX_ID?.trim() || "(ไม่มีข้อมูล)",
        }));

        return {
          data: cleanData,
          totalCount: result.totalCount ?? 0,
        };
      },
    });
  }, [token, stageId]);
  const cellPrepared = (e) => {
    if (e.rowType !== "data") return;
    const yesNoIcon = (val) => (val ? "✔️" : "❌");
    const field = e.column.dataField;
    const rowData = e.data; // ข้อมูลทั้งแถว
    const smfCode = rowData.SMF_CUSCODE;
    if (field === "CUSTOMER_STATUS_EN") {
      e.cellElement.innerHTML = `<span class='status-button badge badge-status-${e.data[
        field
      ]
        .toLowerCase()
        .replace(/[\s()]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}'><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #fff;'>${
        e.data[field]
      }</a></span>`;
    }
    if (field === "CUSTOMER_TYPE_EN") {
      e.cellElement.innerHTML = `<span class='status-button badge badge-type-${e.data[
        field
      ]
        .toLowerCase()
        .replace(/[\s()]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}'><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #fff;'>${
        e.data[field]
      }</a></span>`;
    }
  };
  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">Customers</h5>
      <Box sx={{ maxHeight: 500, overflow: "auto" }}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={customerDataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="CRM_CUSCODE"
          height={500}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <ColumnFixing enabled={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={false} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <Column
            dataField="CRM_CUSCODE"
            caption="CRM_CUSCODE"
            visible={false}
          />
          <Column
            dataField="CUSTOMER_NAME"
            caption="Customer"
            allowHiding={false}
          />
          <Column dataField="CUSTOMER_STATUS_EN" caption="Stage" />
          <Column dataField="CUSTOMER_TYPE_EN" caption="Type" />
          <Column
            dataField="CREATE_DATE"
            caption="Date"
            dataType="date" // ให้เป็น date (หรือ 'datetime' ถ้าต้องการเวลา)
            format="dd-MMM-yyyy HH:mm"
            groupInterval="day" // สำคัญ: บอกให้ HeaderFilter รู้ว่าจะจัดกลุ่มเป็นวัน
          ></Column>
        </DataGrid>
      </Box>
    </div>
  );
}
